import { createStore } from "vuex";
import persistedState from "vuex-persistedstate";
import { spaceEdge } from "@/api/home";
import commonList from "./modules/commonList";
import { getRouters, getUserInfo } from "@/api/system";
import Cookies from "js-cookie";
const store = createStore({
  plugins: [persistedState()],
  modules: {
    commonList
  },
  state() {
    return {
      userInfo: {
        username: "",
        password: "",
      },
      loginUserInfo: {},
      client: {
        clientCode: "",
      },
      userVO: {},
      clientVO: {},
      carInformationLogin: [],
      routers: [],
      parkInfo: {},
      userInfoList: [],
      parkParamConfig: {}, // 车场参数配置
    };
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setClient(state, client) {
      state.client = client;
    },
    setClientVO(state, clientVO) {
      state.clientVO = clientVO;
    },
    setUserVO(state, userVO) {
      state.userVO = userVO;
    },
    loginOut(state) {
      Cookies.remove("token");
      Cookies.remove("token_type");
      Cookies.remove("platform");
      state.parkInfo = {};
      state.routers = [];
      state.userInfo = {
        username: "",
        password: "",
      };
      state.loginUserInfo = {};
      state.parkParamConfig = {}; // 车场参数配置
      (state.client = {
        clientCode: "",
      }),
        (state.userVO = {});
    },
    setCarInformationLogin(state, data) {
      state.carInformationLogin = [];
      state.carInformationLogin = data;
    },
    setRouters(state, routers) {
      state.routers = routers;
    },
    setLoginUserInfo(state, loginUserInfo) {
      state.loginUserInfo = loginUserInfo;
    },
    setParkInfo(state, parkInfo) {
      state.parkInfo = parkInfo;
    },
    setUserInfoList(state, data) {
      // userId 统一归一为数字，避免历史上字符串/数字类型不一致
      const userId = Number(data.userId);
      // 收集同一 userId 的所有记录（含持久化里残留的、类型不一致产生的重复）
      const matches = state.userInfoList.filter((item) => Number(item.userId) === userId);
      // 合并这些重复记录已有的字段（后者覆盖前者），并把 userId 固定为数字
      const merged = Object.assign(
        { parkId: null, clientId: null, parkName: null, videoLayout: null },
        ...matches,
        { userId },
      );
      // 用本次提交带来的字段覆盖（只覆盖显式传入的字段）
      if (data.parkId !== undefined) merged.parkId = data.parkId;
      if (data.clientId !== undefined) merged.clientId = data.clientId;
      if (data.deptId !== undefined) merged.deptId = data.deptId;
      if (data.parkName !== undefined) merged.parkName = data.parkName;
      if (data.videoLayout !== undefined) merged.videoLayout = data.videoLayout;
      // 删除所有旧的重复记录，放回合并后的唯一一条（自愈去重）
      state.userInfoList = state.userInfoList.filter((item) => Number(item.userId) !== userId);
      state.userInfoList.push(merged);
    },
    setParkParamConfig(state, parkParamConfig) {
      state.parkParamConfig = parkParamConfig;
    },
  },
  getters: {
    currentUserId: (state) => state.loginUserInfo?.user?.userId,
    currentUserInfo: (state, getters) =>
      state.userInfoList.find((item) => Number(item.userId) === Number(getters.currentUserId)) || {},
    currentParkId: (state, getters) => getters.currentUserInfo.parkId,
    currentClientId: (state, getters) => getters.currentUserInfo.clientId,
    currentDeptId: (state, getters) => getters.currentUserInfo.deptId,
    currentParkName: (state, getters) => getters.currentUserInfo.parkName,
  },
  actions: {
    // 获取车库信息列表
    async getSpacePark({ commit }) {
      let arr = [];
      let res = await spaceEdge();
      if (res && res.code === 200) {
        arr = res.data.list;
        arr.forEach((ele) => {
          ele.isEdit = true;
          ele.isEditType = "0";
        });
        commit("setCarInformationLogin", arr);
      }
    },
    // 更新车库信息列表
    changeSpace({ commit }, data) {
      commit("setCarInformationLogin", data);
    },
    getRouters({ commit }) {
      return getRouters().then(res => {
        if (res && res.code === 200 && res.data.length > 0) {
          let arr = res.data.filter(item => item.name == 'GuardBooth');
          commit("setRouters", arr);
          return arr;
        }
        commit("setRouters", []);
        return [];
      });
    },
    getInfo({ commit }) {
      return getUserInfo().then(res => {
        if (res && res.code === 200) {
          let obj = {
            user: res.user,
            permissions: res.permissions,
            roles: res.roles,
          }
          if (res.user) {
            if (Cookies.get('platform') === 'admin_project') {
              commit("setUserInfoList", {
                userId: res.user.userId,
                deptId: res.user.deptId,
                parkId: res.user.parkId,
              });
            } else {
              commit("setUserInfoList", {
                userId: res.user.userId,
                deptId: res.user.deptId,
              });
            }
          }
          commit("setLoginUserInfo", obj);
        }
      })
    }
  },
});

export default store;
